import React from 'react';
import {
	Router,
	Route,
	Switch,
	Link
} from 'react-router-dom';

import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import Axios from 'axios';
import moment from 'moment';

// Router: General
import AdminGeneral from './Admin_General';
import AdminSeasons from './Admin_Seasons';

// App
import * as myConstClass from '../shared/constants/constants';
import Users from '../users/Users';

// Refs:  React router and tabs
// https://github.com/reactstrap/reactstrap/issues/83#issue-168537815
// https://github.com/reactstrap/reactstrap/issues/298
// https://codesandbox.io/s/github/browniefed/tmp/tree/reactRouterDynamicRoutes/?from-embed
// https://stackoverflow.com/questions/51203888/reactjs-routing-to-different-tabs

// ADMIN MAINTENANCE SPECIAL CONSTANT
const ADMIN_MAINTENANCE_RESTRICTED_TO_MASTER = false;

const ADMIN_LVL_MASTER = 0;
const ADMIN_LVL_CHARTERS = 1;
const ADMIN_LVL_LEAGUES = 2;
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;
const ADMIN_LVL_ADMINLIMIT = 20;
const ADMIN_LVL_NOACCESS = 99;

class Admin extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			adminPageIdx: 'seasons',
			isAuthenticated: this.props.auth.isAuthenticated(),
			profile: this.props.auth.getProfile(),
			adminAccess: {
				auth: this.props.auth,
				globalAccessLevel: ADMIN_LVL_NOACCESS,
				adminValidatedAccessLevel: ADMIN_LVL_NOACCESS,
				charterAdmin: ''
			},
			bRateSysExists: false
		};
	
		this.dispAdminPageAccess = this.dispAdminPageAccess.bind(this);
		this.dispAdminPage = this.dispAdminPage.bind(this);
		this.getAdminRightsInfo = this.getAdminRightsInfo.bind(this);
		this.admGenClicked = this.admGenClicked.bind(this);
		this.admSeasonClicked = this.admSeasonClicked.bind(this);
	}

	componentDidMount() {
		//console.log('ADMIN: componentDidMount');
		//console.log(this.props)

		this.getAdminRightsInfo();

		// console.log(this.props.location.pathname);
		if (this.props.location.pathname !== '/admsafe/home') {
			this.props.history.push('/admsafe/home');
		}
	}

	UNSAFE_componentWillReceiveProps(nextprops) {
		//console.log('ADMIN: UNSAFE_componentWillReceiveProps');
		//console.log(nextprops.location.pathname);

		if (nextprops.location.pathname === '/admsafe/home') {
			this.setState({ adminPageIdx: 'seasons'})
		}
	}

	render() {
		console.log('ADMIN: render');
		console.log('this.state.adminAccess.globalAccessLevel: ' + this.state.adminAccess.globalAccessLevel);
		console.log('this.state.adminAccess.adminValidatedAccessLevel: ' + this.state.adminAccess.adminValidatedAccessLevel);
		//console.log('ADMIN this.props')
		//console.log(this.props)

		return (
			<div className="animated fadeIn">
			<div className="row row-margin-bottom-100">
			<div className="col-md-12 col-xs-12">
				<h3>Menu Administrateur</h3>
				<br/>
				{this.state.isAuthenticated ? this.dispAdminPageAccess() : this.dispNoAccess()}
			</div>
			</div>
			</div>
		)
	}

	dispNoAccess() {
		return (
			<div>
				<p>Vous devez être connecté pour visualiser le menu Admin.<br/>
				Cliquez sur <b>Se connecter</b> dans la barre de gauche.<br/></p>
			</div>
		)
	}

	dispAdminPageAccess() {
		var bAdminLvl = this.state.adminAccess.globalAccessLevel;
		var adminAccesOK = (!ADMIN_MAINTENANCE_RESTRICTED_TO_MASTER || (bAdminLvl === ADMIN_LVL_MASTER));

		if (adminAccesOK) {
			return (this.dispAdminPage());
		} else {
			return (
				<div>
				<p>Section Admin en maintenance</p>
				<p>Revenez un peu plus tard.  Merci.</p>
				</div>
			);
		}
	}

	dispAdminPage() {
		var bAdminLvl = this.state.adminAccess.globalAccessLevel;
		var bRateSysExists = this.state.bRateSysExists;
		// bAdminLvl = 3;	// force for tests
		return (
			<div>
				{/* ----------------- UTILISATEUR ---------------- */}
				<div className="row">
					<div className="col-md-1 col-xs-1">
						<img className="img-profile-token" src={this.state.profile.picture}/>
					</div>
					<div className="col-md-6 col-xs-6">
						<h5><b>Utilisateur:</b> {this.state.profile.name}</h5>
						<h5><b>Niveau:</b> {bAdminLvl}&nbsp;
							({Users.getAccessLevelText(bAdminLvl)})</h5>
					</div>
				</div>
				<br/>

				{this.dispAdminButtons(bAdminLvl)}

				{(this.state.adminPageIdx === "seasons") ?
					<AdminSeasons props={this.props} auth={this.props.auth} history={this.props.history} />
					: null}

				{(this.state.adminPageIdx === "general") ?
					<AdminGeneral props={this.props} auth={this.props.auth} history={this.props.history} />
					: null}

				<br/>
			</div>
		)
	}

	dispAdminButtons(bAdminLvl) {
		var genBtnClass = 'btn-primary';
		var seasonsBtnClass = 'btn-secondary';
		if (this.state.adminPageIdx === "seasons") {
			genBtnClass = 'btn-secondary';
			seasonsBtnClass = 'btn-primary';			
		}

		if (bAdminLvl === ADMIN_LVL_MASTER) {
			return (
				<div className="row">
				<div className="col-md-12">
					<button className={"btn " + seasonsBtnClass + " adminMenuButton1 btn-margin-right-10"} onClick={this.admSeasonClicked}>
						Admin - Ligues et Saisons
					</button>
					<button className={"btn " + genBtnClass + " adminMenuButton1 btn-margin-right-10"} onClick={this.admGenClicked}>
						Admin Général
					</button>
					<br/><br/>
				</div>
				</div>
			)
		}
	}

	admSeasonClicked() {
		this.setState({ adminPageIdx: 'seasons'})
		this.props.history.push('/admsafe/home');
	}

	admGenClicked() {
		this.setState({ adminPageIdx: 'general'})		
		this.props.history.push('/admsafe/masteradmin');
	}

	getAdminRightsInfo() {

		// console.log('Admin: getAdminRightsInfo');
		var _this = this;
		var charterId = 0;  // temp
		var adminAccess = this.state.adminAccess;

		if (this.state.isAuthenticated) {
			Users.getAccessLevel(_this.state.profile, function(globalAccessLevel) {
			Users.getValidateAccessLevel(_this.state.profile, charterId, '0', '0', function(validatedAccessLevel) {
			Users.getCharterAdmin(_this.state.profile, function(charterAdmin) {

				// console.log('Admin: setState: getAdminRightsInfo');
				// console.log(adminAccess);
				adminAccess.globalAccessLevel = globalAccessLevel;
				adminAccess.adminValidatedAccessLevel = validatedAccessLevel;
				adminAccess.charterAdmin = charterAdmin;

				_this.setState({
					adminAccess: adminAccess
				});
		
			});
			});
			});

		} else {
			adminAccess.globalAccessLevel = ADMIN_LVL_NOACCESS;
			adminAccess.adminValidatedAccessLevel = ADMIN_LVL_NOACCESS;
			adminAccess.charterAdmin = '';
			this.setState({
				adminAccess: adminAccess
			});
		}
	}

};

export default Admin;
